import { all, call, put, takeEvery } from "redux-saga/effects";

import { setUser, getUser, patchUser, getOauthUser } from "../../reducers/userSlice";
import {
  getOAuthUserDetails,
  getUserDetails,
  updateUserDetailsRequest,
} from "../../../utils/api/apis";

function* fetchUserDetails(action) {
  try {
    const userDetails = yield call(getUserDetails, action.payload);
    yield put(setUser(userDetails));
  } catch (error) {
   
  }
}


function* updateUserDetails(action) {
  try {
    const updatedDetails = yield call(updateUserDetailsRequest, action.payload);
    yield put(setUser(updatedDetails));
  } catch (err) {
   
  }
}

export default function* userSaga() {
  yield all([
    takeEvery(getUser.type, fetchUserDetails),
    takeEvery(patchUser.type, updateUserDetails),
  ]);
}
